import { BackArrow } from "lola-framework-ui-test";
import type { JSX } from "react";
import { renderBankAccountLine } from "../../../../utils/bankAccountLine";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
}

export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange = () => {},
  color = "#252525",
  fee,
  className = "",
}) => {
  return (
    <section
      className={`payout-container-content glass gradient-card ${className}`.trim()}
      onClick={onChange}
    >
      <section className="payout-container-info">
        <section className="payout-icon-container">{icon}</section>
        <p className="payout-text-info foreground">
          {renderBankAccountLine(title)}
          <label className="muted-foreground">{renderBankAccountLine(subtitle)}</label>
        </p>
      </section>
      {fee ? (
        fee
      ) : (
        <BackArrow className="right-icon flavor-c-icon" size={30} colors={[color, color]} />
      )}
    </section>
  );
};
